import useApiHelpers from "@/composables/api/helpers";

const { getRequest } = useApiHelpers();

export default function useNFTOrderEndpoints() {
  const getNFTAsset = async (nftReferenceId) => {
    return await getRequest(`/nft/${nftReferenceId}`);
  };

  return {
    getNFTAsset
  };
}
